// extracted by mini-css-extract-plugin
export default {"download-btn":"DownloadPdfButton_download-btn__A-qtQ","preview-btn":"DownloadPdfButton_preview-btn__fLBy0"};